import { render, staticRenderFns } from "./BookSearchContent.vue?vue&type=template&id=912c7af6"
import script from "./BookSearchContent.vue?vue&type=script&lang=js"
export * from "./BookSearchContent.vue?vue&type=script&lang=js"
import style0 from "./BookSearchContent.vue?vue&type=style&index=0&id=912c7af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports